<template>
    <div class="page container-fluid container-table">
        <particles-bg type="cobweb" :bg="true" num=200 color="#303030" />
        <div class="row vertical-center-row text-center text-light">
            <div class="card-deck col-sm-8 mx-auto">
                <div class="card rounded">
                    <div class="card-body">
                        <h1 class="card-title display-4"><router-link to="/mode/presets"><i class="fas fa-boxes text-light text-neon"></i></router-link></h1>
                        <h3 class="card-title">Nuestras PC's</h3>
                        <p class="card-text small pb-3">Solicita armar tu equipo a partir de nuestras propuestas establecidas.</p>
                        <small class="text-muted h2"><router-link to="/mode/presets"><i class="fas fa-chevron-down text-light"></i></router-link></small>
                    </div>
                </div>
                <div class="card rounded">
                    <div class="card-body">
                        <h1 class="card-title display-4"><router-link to="/mode/advanced"><i class="fas fa-cogs text-light text-neon"></i></router-link></h1>
                        <h3 class="card-title">Avanzado</h3>
                        <p class="card-text small pb-3">Ten el control de todos los componentes para una PC a tus necesidades.</p>
                        <small class="text-muted h2"><router-link to="/mode/advanced"><i class="fas fa-chevron-down text-light"></i></router-link></small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Mode',
}
</script>

<style>

.card {
    background-color: transparent !important;
    border: none;
}

.card:hover {
    box-shadow:
		0 0 5px rgba(0,178,255,1),
		0 0 10px rgba(0,178,255,1),
		0 0 15px rgba(0,178,255,1),
		0 0 20px rgba(38,104,127,1),
		0 0 25px rgba(38,104,127,1),
		0 0 30px rgba(38,104,127,1),
		0 0 35px rgba(38,104,127,1),
		0 0 40px rgba(38,104,127,1),
		0 0 45px rgba(38,104,127,1);
}

</style>